"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";
import CSSTransition from "react-addons-css-transition-group";
export default class Busy extends Component {

    static propTypes = {
        value: PropTypes.value,
        styleClass: PropTypes.style,
        message: PropTypes.content
    };
    static defaultProps = {
        value: "_internal.busy",
        styleClass: "Busy"
    };

    renderBusy() {
        const {busyClass, busyIconClass, messageClass, children, message} = this.props;
        return (<div key="busy" className={busyClass}>
            <i className={busyIconClass}/>
            {message ? <RenderContent content={message} className={messageClass}>{children}</RenderContent> : null}
        </div>);
    }

    render() {
        const {styleClass} = this.props;
        return (<CSSTransition
                transitionName={styleClass}
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}>
                {this.props.value ? this.renderBusy() : null}
            </CSSTransition>
        );
    }

}


/** WEBPACK FOOTER **
 ** ./src/types/busy/Busy.jsx
 **/